<div class="ap-choice">
    <div class="ap-choice-head">
        <label class="ap-choice-label" for="ap-choice-select">{{ section.label }}</label>
        <span
            *ngIf="confidenceLabel as label"
            class="ap-confidence-badge"
            [class.tone-high]="confidence === 'high'"
            [class.tone-review]="confidence === 'review'"
            [class.tone-low]="confidence === 'low'">
            {{ label }}
        </span>
    </div>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="ap-choice-field">
        <mat-select
            id="ap-choice-select"
            [panelClass]="'gable-select-panel'"
            [value]="value"
            (selectionChange)="onSelectionChange($event.value)"
            [attr.aria-label]="section.label">
            <mat-option
                *ngFor="let option of section.options; trackBy: trackByOptionValue"
                [value]="option.value">
                {{ option.label }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <p class="ap-choice-hint" *ngIf="section.hint as hint">{{ hint }}</p>

    <p class="ap-choice-outcome" *ngIf="effectPrefix && selectedLabel as label">
        <i class="ph-bold ph-arrow-right icon-12 ap-choice-arrow" aria-hidden="true"></i>
        <span>{{ effectPrefix }} {{ label }}</span>
    </p>
</div>
